// With `inline` (the default) the video plays within the iframe; without it iOS
// hands playback to the device's own fullscreen player, keeping it out of the
// YouTube app.
export function youtubeEmbedSrc(id: string, inline = true): string {
  const params = `enablejsapi=1&autoplay=1&rel=0&modestbranding=1${inline ? "&playsinline=1" : ""}`;
  return `https://www.youtube-nocookie.com/embed/${id}?${params}`;
}

// maxresdefault (1280×720) 403s for Shorts/some videos — see posterFallback.
export function youtubeThumbnail(id: string): string {
  return `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
}

// onError: swap a missing maxres thumbnail for the always-present hqdefault.
export function posterFallback(e: { currentTarget: HTMLImageElement }): void {
  const img = e.currentTarget;
  if (img.src.includes("/maxresdefault.jpg")) {
    img.src = img.src.replace("/maxresdefault.jpg", "/hqdefault.jpg");
  }
}
